module.exports = __webpack_public_path__ + "img/big-img-kuang2.5af64d64.png";